import { TotalCostOptimizationsActionTypes } from './constants';
import { PAGINATION_DEFAULT_VALUE } from '../../helpers/defaultValue';

export const INIT_STATE = {
    loadingTotalChargeAmount: false,
    totalChargeAmount: null,
    errorTotalChargeAmount: null,
    loadingTotalAuditableAmount: false,
    totalAuditableAmount: null,
    errorTotalAuditableAmount: null,
    loadingAvgTotalChargeAmount: false,
    avgTotalChargeAmount: null,
    errorAvgTotalChargeAmount: null,
    loadingTotalCostByWeightAndZone: false,
    totalCostByWeightAndZone: null,
    errorTotalCostByWeightAndZone: null,
    loadingComparisonTotalChargeAmount: false,
    comparisonTotalChargeAmount: null,
    errorComparisonTotalChargeAmount: null,
    loadingComparisonAvgTotalChargeAmount: false,
    comparisonAvgTotalChargeAmount: null,
    errorComparisonAvgTotalChargeAmount: null,
};

type TotalCostOptimizationsAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

//TODO: define data type for orders
type State = {
    loadingTotalChargeAmount: Boolean,
    totalChargeAmount: any,
    errorTotalChargeAmount: any,
    loadingTotalAuditableAmount: Boolean,
    totalAuditableAmount: any,
    errorTotalAuditableAmount: any,
    loadingAvgTotalChargeAmount: Boolean,
    avgTotalChargeAmount: any,
    errorAvgTotalChargeAmount: any,
    loadingTotalCostByWeightAndZone: Boolean,
    totalCostByWeightAndZone: any,
    errorTotalCostByWeightAndZone: any,
    loadingComparisonTotalChargeAmount: Boolean,
    comparisonTotalChargeAmount: any,
    errorComparisonTotalChargeAmount: any,
    loadingComparisonAvgTotalChargeAmount: Boolean,
    comparisonAvgTotalChargeAmount: any,
    errorComparisonAvgTotalChargeAmount: any,
};

const TotalCostOptimizations = (state: State = INIT_STATE, action: TotalCostOptimizationsAction): any => {
    switch (action.type) {
        case TotalCostOptimizationsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case TotalCostOptimizationsActionTypes.GET_TOTAL_CHARGE_AMOUNT: {
                    return { ...state, loadingTotalChargeAmount: false, totalChargeAmount: action.payload.data };
                }
                case TotalCostOptimizationsActionTypes.GET_TOTAL_AUDITABLE_AMOUNT: {
                    return { ...state, loadingTotalAuditableAmount: false, totalAuditableAmount: action.payload.data };
                }
                case TotalCostOptimizationsActionTypes.GET_AVG_TOTAL_CHARGE_AMOUNT: {
                    return { ...state, loadingAvgTotalChargeAmount: false, avgTotalChargeAmount: action.payload.data };
                }
                case TotalCostOptimizationsActionTypes.GET_COMPARISON_TOTAL_CHARGE_AMOUNT: {
                    return { ...state, loadingComparisonTotalChargeAmount: false, comparisonTotalChargeAmount: action.payload.data };
                }
                case TotalCostOptimizationsActionTypes.GET_COMPARISON_AVG_TOTAL_CHARGE_AMOUNT: {
                    return { ...state, loadingComparisonAvgTotalChargeAmount: false, comparisonAvgTotalChargeAmount: action.payload.data };
                }
                case TotalCostOptimizationsActionTypes.GET_TOTAL_COST_BY_WEIGHT_AND_ZONE: {
                    return { ...state, loadingTotalCostByWeightAndZone: false, totalCostByWeightAndZone: action.payload.data };
                }
                default:
                    return { ...state, loadingTotalChargeAmount: false, loadingTotalAuditableAmount: false, loadingAvgTotalChargeAmount: false, loadingComparisonTotalChargeAmount: false, loadingComparisonAvgTotalChargeAmount: false, loadingTotalCostByWeightAndZone: false };
            }

        case TotalCostOptimizationsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case TotalCostOptimizationsActionTypes.GET_TOTAL_CHARGE_AMOUNT: {
                    return { ...state, loadingTotalChargeAmount: false, errorTotalChargeAmount: action.payload.error };
                }
                case TotalCostOptimizationsActionTypes.GET_TOTAL_AUDITABLE_AMOUNT: {
                    return { ...state, loadingTotalAuditableAmount: false, errorTotalAuditableAmount: action.payload.error };
                }
                case TotalCostOptimizationsActionTypes.GET_AVG_TOTAL_CHARGE_AMOUNT: {
                    return { ...state, loadingAvgTotalChargeAmount: false, errorAvgTotalChargeAmount: action.payload.error };
                }
                case TotalCostOptimizationsActionTypes.GET_COMPARISON_TOTAL_CHARGE_AMOUNT: {
                    return { ...state, loadingComparisonTotalChargeAmount: false, errorComparisonTotalChargeAmount: action.payload.error };
                }
                case TotalCostOptimizationsActionTypes.GET_COMPARISON_AVG_TOTAL_CHARGE_AMOUNT: {
                    return { ...state, loadingComparisonAvgTotalChargeAmount: false, errorComparisonAvgTotalChargeAmount: action.payload.error };
                }
                case TotalCostOptimizationsActionTypes.GET_TOTAL_COST_BY_WEIGHT_AND_ZONE: {
                    return { ...state, loadingTotalCostByWeightAndZone: false, errorTotalCostByWeightAndZone: action.payload.error };
                }
                default:
                    return { ...state };
            }

        case TotalCostOptimizationsActionTypes.GET_TOTAL_CHARGE_AMOUNT:
            return { ...state, loadingTotalChargeAmount: true, totalChargeAmount: null };
        case TotalCostOptimizationsActionTypes.GET_TOTAL_AUDITABLE_AMOUNT:
            return { ...state, loadingTotalAuditableAmount: true, totalAuditableAmount: null };
        case TotalCostOptimizationsActionTypes.GET_AVG_TOTAL_CHARGE_AMOUNT:
            return { ...state, loadingAvgTotalChargeAmount: true, avgTotalChargeAmount: null };
        case TotalCostOptimizationsActionTypes.GET_COMPARISON_TOTAL_CHARGE_AMOUNT:
            return { ...state, loadingComparisonTotalChargeAmount: true, comparisonTotalChargeAmount: null };
        case TotalCostOptimizationsActionTypes.GET_COMPARISON_AVG_TOTAL_CHARGE_AMOUNT:
            return { ...state, loadingComparisonAvgTotalChargeAmount: true, comparisonAvgTotalChargeAmount: null };
        case TotalCostOptimizationsActionTypes.GET_TOTAL_COST_BY_WEIGHT_AND_ZONE:
            return { ...state, loadingTotalCostByWeightAndZone: true, totalCostByWeightAndZone: null };
        default:
            return { ...state };
    }
};

export default TotalCostOptimizations;
